import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { addLockedAccount } from 'actions/lockedAccountForm'
import LockedAccountDisplayForm from 'views/AccountsAndLoans/LockedAccountDisplayForm'

class LockedAccountForm extends Component {
  static propTypes = {
    accountsAndLoans: PropTypes.object.isRequired,
    currentUser: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object.isRequired,
    hide: PropTypes.func.isRequired,
    id: PropTypes.string,
    lockedAccountForm: PropTypes.object.isRequired,
    modals: PropTypes.object.isRequired,
  }

  static defaultProps = {
    id: 'lockedAccountForm',
    currentUser: null,
  }

  _submit = (data) => {
    const formData = {
      employee_id: this.props.currentUser.EmployeeId,
      loginname: '',
      accountprefix: (data.account ? data.account : ''),
    }
    if (data.account) {
      this.props.dispatch(addLockedAccount(formData, this.props.id))
    }
  }

  render() {
    const {
      modals, hide, forms, id, accountsAndLoans, lockedAccountForm,
    } = this.props
    return (
      <LockedAccountDisplayForm
        accountsAndLoans={accountsAndLoans}
        dispatch={this.props.dispatch}
        forms={forms}
        handleSubmit={this._submit}
        hide={hide}
        id={id}
        lockedAccountForm={lockedAccountForm}
        modals={modals}
        title="Add a new account to be locked"
      />
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  modals: state.modals,
  forms: state.forms,
  accountsAndLoans: state.accountsAndLoans,
  lockedAccountForm: state.lockedAccountForm,
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LockedAccountForm))



// WEBPACK FOOTER //
// ./src/containers/LockedAccountForm.js